<template>
  <div style="padding: 20px;">
    <h3>客户反馈</h3>
    <a-form :form="form">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-item label="粪便（分）：">
            <a-rate 
              v-decorator="['shit',{rules:[{required: true,  message: '请填写粪便分'}],}]" 
              :tooltips="desc" 
              :allow-clear="false"
            />
            <span v-if="desc[form.getFieldValue('shit') - 1]" class="ant-rate-text">
              {{ `${desc[form.getFieldValue('shit') - 1]}分` }}
            </span>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item v-if="animalColor == '有色羽'" label="脚胫着色情况">
            <a-select 
              placeholder="请选择"
              v-decorator="['shinsTinting',{rules:[{required: true, message: '请选择脚胫着色情况'}]}]"
            >
              <a-select-option v-for="el in scoreList" :key="el.id" :value="el.id">
                {{ el.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item v-if="animalColor == '有色羽'" label="油脂着色情况">
            <a-select 
              placeholder="请选择"
              v-decorator="['greaseColoration',{rules:[{required: true, message: '请选择油脂着色情况'}]}]"
            >
              <a-select-option v-for="el in scoreList" :key="el.id" :value="el.id">
                {{ el.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="animalColor == '有色羽' ? 24 : 8">
          <a-form-item label="客户满意度（分）：">
            <a-rate 
              v-decorator="['customerSatisfaction',{rules:[{required: true ,message: '请填写客户满意度'}],}]" 
              :tooltips="desc"
              :allow-clear="false"
            />
            <span v-if="desc[form.getFieldValue('customerSatisfaction') - 1]" class="ant-rate-text">
              {{ `${desc[form.getFieldValue('customerSatisfaction') - 1]}分` }}
            </span>
          </a-form-item>
        </a-col>
      </a-row>
      <div>
        <span>图片：</span>
        <div class="clearfix">
          <a-upload
            list-type="picture-card"
            :file-list="fileList"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            :remove="handleRemove"
          >
            <div v-if="fileList.length < 10">
              <a-icon type="plus" />
              <div class="ant-upload-text">Upload</div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </div>
      <br>
      <div class="mp4upload">
        <span>视频：</span>
        <a-upload-dragger
          name="file"
          :multiple="true"
          :file-list="videoFileList"
          :before-upload="beforeUploadVideo"
          :remove="handleRemoveVideo"
        >
          <p class="ant-upload-drag-icon" ><a-icon type="inbox" /></p>
          <p class="ant-upload-text">点击或将 mp4 格式视频拖拽到这里上传</p>
        </a-upload-dragger>
      </div>
      <br>
      <a-form-item label="其他意见：">
        <a-textarea placeholder="请输入" v-decorator="['remark']" :max="500" style="height: 50px;width: 800px;"/>
      </a-form-item>
    </a-form>
  </div>
  
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
import {scoreList} from './Lists'
export default {
  props:['poultryLineFeedback','fileListProp','animalColor'],
  data(){
    return {
      form: this.$form.createForm(this, { name: 'score' }),
      desc: ['1.0', '2.0', '3.0', '4.0', '5.0'],
      scoreList,
      previewVisible: false,
      previewImage: '',
      fileList:this.fileListProp.fileList,
      videoFileList:this.fileListProp.videoFileList,
    };
  },
  mounted(){
    this.form.setFieldsValue(this.poultryLineFeedback)
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    async beforeUpload(file) {
      const formData = new FormData();
      formData.append('file', file);
      let res = await this.$http.post('/sat-collect/upload/uploadFile',formData)
      if(!res.success) file.status = 'error'
      else{
        file.fileName = res.data.picName
        file.url = res.data.picLink
      }
      this.fileList = [...this.fileList, file];
      return new Promise((reslove, reject) => {return reject(false);});
    },
    async beforeUploadVideo(file) {
      const formData = new FormData();
      formData.append('file', file);
      let res = await this.$http.post('/sat-collect/upload/uploadFile',formData)
      if(!res.success) file.status = 'error'
      else{
        file.fileName = res.data.picName
        file.url = res.data.picLink
      }
      this.videoFileList = [...this.videoFileList, file];
      return new Promise((reslove, reject) => {return reject(false);});
    },
    async handleRemove(file){
      const fileName = file.fileName
      let res = await this.$http.get('/sat-collect/upload/deleteFile',{ params:{fileName} })
      if(res.success){
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      }else {
        this.$message.error('删除失败')}
        return false
    },
    async handleRemoveVideo(file){
      const fileName = file.fileName
      let res = await this.$http.get('/sat-collect/upload/deleteFile',{ params:{fileName} })
      if(res.success){
        const index = this.videoFileList.indexOf(file);
        const newFileList = this.videoFileList.slice();
        newFileList.splice(index, 1);
        this.videoFileList = newFileList;
      }else {
        this.$message.error('删除失败')}
        return false
    },
    sendData() {
      const uploadFiles = []
      this.fileList.forEach(item => {
        uploadFiles.push({
          mediaType:'PIC',
          fileName:item.fileName
        })
      })
      this.videoFileList.forEach(item => {
        uploadFiles.push({
          mediaType:'VIDEO',
          fileName:item.fileName
        })
      })
      const val =this.form.getFieldsValue()
      this.$emit('setFeedBack', {...val, uploadFiles})
      this.$emit('setFileList',{fileList: this.fileList, videoFileList: this.videoFileList})
    },
  },
}
</script>

<style>
.mp4upload{
  width: 50%;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}
.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.ant-form label{
  font-size: 14px !important;
}
</style>